import script from "./groupDetailsCom.vue?vue&type=script&setup=true&lang=js"
export * from "./groupDetailsCom.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__